import { render } from "./StartView.vue?vue&type=template&id=7afcb1de"
const script = {}

import exportComponent from "C:\\Documents\\git\\uo_epilot\\Resources\\Public\\Scripts\\checkout\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__